<template>
    <CommandItem :value="true" class="group">
        <span class="border rounded px-1 mr-2 group-data-[state=checked]:bg-primary">
            <i class="fass fa-check invisible text-white group-data-[state=checked]:visible"></i>
        </span>
        <span><slot /></span>
    </CommandItem>
</template>
